// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD9xklHh8_GUfLIg8znUymIQrKplvnJc88",
  authDomain: "italy-food-324ab.firebaseapp.com",
  projectId: "italy-food-324ab",
  storageBucket: "italy-food-324ab.appspot.com",
  messagingSenderId: "496272433333",
  appId: "1:496272433333:web:ef4c69ebdafc37cb9b9efc"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app;